import React, { useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    Alert,
    LinearProgress,
    Tooltip,
    Button
} from '@mui/material';
import {
    AdminPanelSettings as AdminIcon,
    Business as BusinessIcon,
    Person as PersonIcon,
    Schedule as ScheduleIcon,
    AccountBalance as BalanceIcon
} from '@mui/icons-material';

/**
 * Componente para exibir informações de permissões e saldo de rodadas
 */
const RodadaPermissionsCard = ({ permissions, loading }) => {
    const [minimized, setMinimized] = useState(false);

    if (loading) {
        return (
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <LinearProgress />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Carregando permissões...
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    const getTipoPerfilIcon = () => {
        if (permissions.isAdmin) return <AdminIcon />;
        if (permissions.isEmpresa) return <BusinessIcon />;
        return <PersonIcon />;
    };

    const getTipoPerfilColor = () => {
        if (permissions.isAdmin) return 'error';
        if (permissions.isEmpresa) return 'success';
        return 'primary';
    };

    const getTipoPerfilLabel = () => {
        if (permissions.isAdmin) return 'ADMINISTRADOR';
        if (permissions.isEmpresa) return 'EMPRESA';
        return 'COLABORADOR';
    }; const formatDate = (dateStr) => {
        if (!dateStr) return 'Ilimitado';
        return new Date(dateStr).toLocaleDateString('pt-BR');
    };

    const formatSaldo = (saldo, suffix = '') => {
        console.log('saldo', saldo)
        if (saldo === 0 || saldo === "" || saldo === null || saldo === undefined) {
            return 'Ilimitado';
        }
        return saldo.toString() + suffix;
    };

    const isContractExpired = () => {
        if (!permissions.dataFimContrato) return false;
        return new Date() > new Date(permissions.dataFimContrato);
    };

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent sx={{ p: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: minimized ? 0 : 2, justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Chip
                            icon={getTipoPerfilIcon()}
                            label={getTipoPerfilLabel()}
                            color={getTipoPerfilColor()}
                            variant="outlined"
                        />
                        {permissions.canCreate ? (
                            <Chip label="Pode Cadastrar" color="success" size="small" />
                        ) : (
                            <Chip label="Não Pode Cadastrar" color="error" size="small" />
                        )}
                        {permissions.canEdit && (
                            <Chip label="Pode Editar" color="info" size="small" />
                        )}
                        {permissions.isEmpresa && minimized && (
                            <Tooltip title="Saldo de rodadas disponíveis">
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <BalanceIcon color="primary" fontSize="small" />
                                    <Typography variant="body2">
                                        <strong>{formatSaldo(permissions.saldoRodadas)}</strong>
                                    </Typography>
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                    <Box>
                        <Tooltip title={minimized ? 'Expandir' : 'Minimizar'}>
                            <span>
                                <Button size="small" onClick={() => setMinimized(m => !m)} sx={{ minWidth: 32, p: 0.5 }}>
                                    {minimized ? '+' : '-'}
                                </Button>
                            </span>
                        </Tooltip>
                    </Box>
                </Box>
                {!minimized && (
                    <>
                        {/* Informações específicas para empresas */}
                        {permissions.isEmpresa && (
                            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                <Tooltip title="Saldo de rodadas disponíveis">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <BalanceIcon color="primary" fontSize="small" />
                                        <Typography variant="body2">
                                            <strong>{formatSaldo(permissions.saldoRodadas, ' rodadas de saldo')}</strong>
                                        </Typography>
                                    </Box>
                                </Tooltip>
                                <Tooltip title="Data de vencimento do contrato">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <ScheduleIcon
                                            color={isContractExpired() ? 'error' : 'primary'}
                                            fontSize="small"
                                        />
                                        <Typography
                                            variant="body2"
                                            color={isContractExpired() ? 'error' : 'text.primary'}
                                        >
                                            {formatDate(permissions.dataFimContrato)}
                                        </Typography>
                                    </Box>
                                </Tooltip>
                            </Box>
                        )}
                        {/* Alert com informações sobre as permissões */}
                        <Alert
                            severity={
                                permissions.canCreate ? 'success' :
                                    permissions.isEmpresa ? 'warning' : 'info'
                            }
                            sx={{ mt: 1 }}
                        >
                            {permissions.reason}
                        </Alert>
                        {/* Informações adicionais para empresas */}
                        {permissions.isEmpresa && (
                            <Box sx={{ mt: 2, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                                <Typography variant="caption" color="text.secondary">
                                    <strong>Como funciona:</strong>
                                </Typography>
                                <Typography variant="caption" color="text.secondary" component="ul" sx={{ mt: 0.5, pl: 2, mb: 0 }}>
                                    {/* <li><strong>Saldo ilimitado:</strong> Pode cadastrar quantas rodadas desejar</li> */}
                                    <li><strong>Saldo numérico:</strong> Cada rodada consome 1 crédito do saldo</li>
                                    <li><strong>Data limite:</strong> Após vencimento, bloqueia cadastro/edição</li>
                                    <li>Entre em contato com o administrador para ajustes quando necessário</li>
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default RodadaPermissionsCard;
